import PropTypes from "prop-types";
import React from "react";
import { useSelector } from "react-redux";
import { Redirect, useLocation } from "react-router-dom";
import userRoles from "../../store/userRoles";
//-----------------------|| AUTH GUARD ||-----------------------//

/**
 * Authentication guard for routes
 * @param {PropTypes.node} children children element/node
 */
const AuthGuard = ({ children }) => {
  const location = useLocation();
  const pathName = location.pathname;
  const pathNameSplit = pathName.split("/");
  const account = useSelector((state) => state.account);
  const { isLoggedIn } = account;
  if (!isLoggedIn) {
    if (pathNameSplit[1] === "forgot") {
      return <Redirect to="/forgot" />;
    } else {
      return <Redirect to="/login" />;
    }
  } else if (
    account.user_role === userRoles.superAdmin ||
    account.user_role === userRoles.systemAdmin
  ) {
    if (pathNameSplit[1] === "superAdmin") {
      const validPaths = [
        "/superAdmin/home",
        "/superAdmin/user",
        "/superAdmin/device",
        "/superAdmin/meter",
        "/superAdmin/imei",
        "/superAdmin/access",
        "/superAdmin/wms",
        "/superAdmin/dg",
        "/superAdmin/bms",
        "/superAdmin/temp",
        "/superAdmin/hvac",
        "/superAdmin/hooter",
        "/superAdmin/flms",
        "/superAdmin/view",
        "/superAdmin/client",
        "/superAdmin/site",
        "/superAdmin/help",
        "/superAdmin/broadcast",
        "/superAdmin/nbaudit",
      ];
      if (validPaths.includes(pathName)) {
        return children;
      } else if (["/superAdmin/", "/superAdmin"].includes(pathName)) {
        return <Redirect to="/superAdmin/home" />;
      } else {
        return <Redirect to="/notFound" />;
      }
    } else {
      return <Redirect to="/superAdmin" />;
    }
  } else if (
    account.user_role === userRoles.admin ||
    account.user_role === userRoles.masterViewer
  ) {
    if (pathNameSplit[1] === "admin") {
      const validPaths = [
        "/admin/home",
        "/admin/user",
        "/admin/meter",
        "/admin/client",
        "/admin/site",
        "/admin/help",
        "/admin/broadcast",
        // "/admin/nbaudit"
      ];
      if (validPaths.includes(pathName)) {
        return children;
      } else if (["/admin/", "/admin"].includes(pathName)) {
        return <Redirect to="/admin/home" />;
      } else {
        return <Redirect to="/notFound" />;
      }
    } else {
      return <Redirect to="/admin" />;
    }
  }  else if (
    account.user_role === userRoles.supportAdmin
  ) {
    if (pathNameSplit[1] === "supportAdmin") {
      const validPaths = [
        "/supportAdmin/home","/supportAdmin/help",
      ];
      if (validPaths.includes(pathName)) {
        return children;
      } else if (["/supportAdmin/", "/supportAdmin"].includes(pathName)) {
        return <Redirect to="/supportAdmin/home" />;
      } else {
        return <Redirect to="/notFound" />;
      }
    } else {
      return <Redirect to="/supportAdmin" />;
    }
  } else if (account.user_type === 1 || account.user_type === 3) {
    if (pathName === "/route") {
      // console.log(account)
      if (account.user.dashboard_type === 1) {
        return <Redirect to="/ems/home" />;
      } else if (account.user.dashboard_type === 2) {
        return <Redirect to="/wms/home" />;
      } else if (account.user.dashboard_type === 3) {
        return <Redirect to="/dg/home" />;
      } else if (account.user.dashboard_type === 4) {
        return <Redirect to="/bms/home" />;
      } else if (account.user.dashboard_type === 5) {
        return <Redirect to="/temp/home" />;
      } else if (account.user.dashboard_type === 6) {
        return <Redirect to="/hvc/home" />;
      } else if (account.user.dashboard_type === 7) {
        return <Redirect to="/fms/home" />;
      } else if (account.user.dashboard_type === 8) {
        return <Redirect to="/nbs/home" />;
      } else if (account.user.dashboard_type === 9) {
        return <Redirect to="/trans/home" />;
      } else if (account.user.dashboard_type === 10) {
        return <Redirect to="/vib/home" />;
      } else if (account.user.dashboard_type === 11) {
        return <Redirect to="/agr/home" />;
      } else if (account.user.dashboard_type === 12) {
        return <Redirect to="/gas/home" />;
      } else if (account.user.dashboard_type === 13) {
        return <Redirect to="/air/home" />;
      }else if (account.user.dashboard_type === 14) {
        return <Redirect to="/flms/home" />;
      } else if (account.user.dashboard_type === 15) {
        return <Redirect to="/steam/home" />;
      } else if (account.user.dashboard_type === 16) {
        return <Redirect to="/solar/home" />;
      } else if (account.user.dashboard_type === 17) {
        return <Redirect to="/bolier/home" />;
      } else if (account.user.dashboard_type === 18) {
        return <Redirect to="/pump/home" />;
      }
      else {
        return <Redirect to="/ems/home" />;
      }
    } else if (pathNameSplit[1] === "ems") {
      const validPaths = [
        "/ems/home",
        "/ems/analysis",
          "/ems/ai",
        // "/ems/comparison",
        "/ems/mnv",
        "/ems/alarms",
        "/ems/alarms_list",
        "/ems/report_gen",
        "/ems/add_report",
        "/ems/power_log",
        "/ems/kpi",
        "/ems/kpi_bill",
        "/ems/ghg",
        "/ems/support",
        "/ems/all/alert",
        "/ems/transformer",
      ];
      if (validPaths.includes(pathName)) {
        return children;
      } else if (["/ems/", "/ems"].includes(pathName)) {
        return <Redirect to="/ems/home" />;
      } else {
        return <Redirect to="/notFound" />;
      }
    } else if (pathNameSplit[1] === "dg") {
      const validPaths = [
        "/dg/home",
        "/dg/analysis",
        "/dg/alarms",
        "/dg/alarms_list",
        "/dg/report",
        "/dg/all/alert",
        "/dg/schedule",
        "/dg/help",
      ];
      if (validPaths.includes(pathName)) {
        return children;
      } else if (["/dg/", "/dg"].includes(pathName)) {
        return <Redirect to="/dg/home" />;
      } else {
        return <Redirect to="/notFound" />;
      }
    } else if (pathNameSplit[1] === "bms") {
      const validPaths = [
        "/bms/home",
        "/bms/analysis",
        "/bms/alarms",
        "/bms/alarms_list",
        "/bms/report",
        "/bms/all/alert",
        "/bms/schedule",
        "/bms/help",
      ];
      if (validPaths.includes(pathName)) {
        return children;
      } else if (["/bms/", "/bms"].includes(pathName)) {
        return <Redirect to="/bms/home" />;
      } else {
        return <Redirect to="/notFound" />;
      }
    } else if (pathNameSplit[1] === "temp") {
      const validPaths = [
        "/temp/home",
        "/temp/analysis",
        "/temp/alarms",
        "/temp/alarms_list",
        // "/temp/hooter_list",
        "/temp/report",
        "/temp/schedule",
        "/temp/all/alert",
        "/temp/help",

        "/temp/indoor/home",
        "/temp/indoor/alarms_list",
        "/temp/indoor/analysis",
        "/temp/indoor/all/alert",

        "/temp/outdoor/home",
        "/temp/outdoor/alarms_list",
        "/temp/outdoor/analysis",
        "/temp/outdoor/pm10",
        "/temp/outdoor/pm25",
        "/temp/outdoor/co",
        "/temp/outdoor/so2",
        "/temp/outdoor/no2",
        "/temp/outdoor/o3",
        "/temp/weather/home",
        "/temp/weather/analysis",
        "/temp/outdoor/all/alert",

        "/temp/busBar/home",
        "/temp/busBar/alarms_list",
        "/temp/busBar/help",
        "/temp/busBar/all/alert",
      ];
      if (validPaths.includes(pathName)) {
        return children;
      } else if (["/temp/", "/temp"].includes(pathName)) {
        return <Redirect to="/temp/home" />;
      } else {
        return <Redirect to="/notFound" />;
      }
    } else if (pathNameSplit[1] === "fms") {
      const validPaths = [
        "/fms/home",
        "/fms/panel",
        "/fms/analysis",
        "/fms/alarms",
        "/fms/alarms_list",
        "/fms/pumpAnalysis",
        "/fms/pressureAnalysis",
        "/fms/dieselAnalysis",
        "/fms/waterAnalysis",
        "/fms/log",
        "/fms/vent_system",
        "/fms/pa_system",
        "/fms/all/alert",
        "/fms/help",
      ];
      if (validPaths.includes(pathName)) {
        return children;
      } else if (["/fms/", "/fms"].includes(pathName)) {
        return <Redirect to="/fms/home" />;
      } else {
        return <Redirect to="/notFound" />;
      }
    } else if (pathNameSplit[1] === "hvc") {
      const validPaths = [
        "/hvc/home",
        "/hvc/analysis",
        "/hvc/report",
        "/hvc/alarms",
        "/hvc/alarms_list",
        "/hvc/ahu_alarms_list",
        "/hvc/all/alert",
        "/hvc/chiller/alarms_list",
        "/hvc/help",
      ];
      if (validPaths.includes(pathName)) {
        return children;
      } else if (["/hvc/", "/hvc"].includes(pathName)) {
        return <Redirect to="/hvc/home" />;
      } else {
        return <Redirect to="/notFound" />;
      }
    } else if (pathNameSplit[1] === "boiler") {
      const validPaths = [
        "/boiler/home",
        "/boiler/dashboard",
        "/boiler/analysis",
        "/boiler/alarms",
        "/boiler/alarms_list",
        "/boiler/report",
        "/boiler/all/alert",
        "/boiler/schedule",
        "/boiler/help",
      ];
      if (validPaths.includes(pathName)) {
        return children;
      } else if (["/boiler/", "/boiler"].includes(pathName)) {
        return <Redirect to="/boiler/home" />;
      } else {
        return <Redirect to="/notFound" />;
      }
    } else if (pathNameSplit[1] === "pump") {
      const validPaths = [
        "/pump/home",
        "/pump/dash",
        "/pump/analysis",
        "/pump/alarms",
        "/pump/alarms_list",
        "/pump/report",
        "/pump/ai_insights",
        "/pump/all/alert",
        "/pump/schedule",
        "/pump/help",
      ];
      if (validPaths.includes(pathName)) {
        return children;
      } else if (["/pump/", "/pump"].includes(pathName)) {
        return <Redirect to="/pump/home" />;
      } else {
        return <Redirect to="/notFound" />;
      }
    } else if (pathNameSplit[1] === "vib") {
      const validPaths = [
        "/vib/home",
        "/vib/analysis",
        "/vib/overview",
        "/vib/wind",
        "/vib/alarms",
        "/vib/alarms_list",
        "/vib/report",
        "/vib/schedule",
        "/vib/ai_insights",
        "/vib/help",
        "/vib/wind/help",
        "/vib/all/alert",
        "/vib/wind/all/alert",
        "/vib/wind/alarms_list",
        "/vib/wind/analysis"
      ];
      if (validPaths.includes(pathName)) {
        return children;
      } else if (["/vib/", "/vib"].includes(pathName)) {
        return <Redirect to="/vib/home" />;
      } else {
        return <Redirect to="/notFound" />;
      }
    }  else if (pathNameSplit[1] === "wms") {
      const validPaths = [
        "/wms/home",
        "/wms/analysis",
        "/wms/alarms",
        "/wms/alarms_list",
        "/wms/quality_list",
        "/wms/report",
        "/wms/help",
        "/wms/quality",
        "/wms/all/alert",
        "/wms/level",
        "/wms/kpi",
        "/wms/schedule",
      ];
      if (validPaths.includes(pathName)) {
        return children;
      } else if (["/wms/", "/wms"].includes(pathName)) {
        return <Redirect to="/wms/home" />;
      } else {
        return <Redirect to="/notFound" />;
      }
    } else if (pathNameSplit[1] === "trans") {
      const validPaths = [
        "/trans/home",
        "/trans/analysis",
        "/trans/alarms",
        "/trans/alarms_list",
        "/trans/report",
        "/trans/schedule",
        "/trans/all/alert",
        "/trans/help",
      ];
      if (validPaths.includes(pathName)) {
        return children;
      } else if (["/trans/", "/trans"].includes(pathName)) {
        return <Redirect to="/trans/home" />;
      } else {
        return <Redirect to="/notFound" />;
      }
    } else if (pathNameSplit[1] === "nbs") {
      const validPaths = [
        "/nbs/home",
        "/nbs/analysis",
        "/nbs/alarm",
        "/nbs/metering",
        "/nbs/all/alert",
        "/nbs/help",
      ];
      if (validPaths.includes(pathName)) {
        return children;
      } else if (["/nbs/", "/nbs"].includes(pathName)) {
        return <Redirect to="/nbs/home" />;
      } else {
        return <Redirect to="/notFound" />;
      }
    } else if (pathNameSplit[1] === "agr") {
      const validPaths = [
        "/agr/home",
        "/agr/analysis",
        "/agr/alarm",
        "/agr/all/alert",
        "/agr/help",
      ];
      if (validPaths.includes(pathName)) {
        return children;
      } else if (["/agr/", "/agr"].includes(pathName)) {
        return <Redirect to="/agr/home" />;
      } else {
        return <Redirect to="/notFound" />;
      }
    } else if (pathNameSplit[1] === "gas") {
      const validPaths = [
        "/gas/home",
        "/gas/analysis",
        "/gas/alarms",
        "/gas/alarms_list",
        "/gas/report",
        "/gas/schedule",
        "/gas/all/alert",
        "/gas/help",
      ];
      if (validPaths.includes(pathName)) {
        return children;
      } else if (["/gas/", "/gas"].includes(pathName)) {
        return <Redirect to="/gas/home" />;
      } else {
        return <Redirect to="/notFound" />;
      }
    } else if (pathNameSplit[1] === "steam") {
      const validPaths = [
        "/steam/home",
        "/steam/analysis",
        "/steam/alarms",
        "/steam/alarms_list",
        "/steam/report",
        "/steam/all/alert",
        "/steam/schedule",
        "/steam/help",
      ];
      if (validPaths.includes(pathName)) {
        return children;
      } else if (["/steam/", "/steam"].includes(pathName)) {
        return <Redirect to="/steam/home" />;
      } else {
        return <Redirect to="/notFound" />;
      }
    } else if (pathNameSplit[1] === "air") {
      const validPaths = [
        "/air/home",
        "/air/dashboard",
        "/air/power_log",
        "/air/backup_log",
        "/air/analysis",
        "/air/alarms",
        "/air/alarms_list",
        "/air/report",
        "/air/schedule",
        "/air/all/alert",
        "/air/help",
      ];
      if (validPaths.includes(pathName)) {
        return children;
      } else if (["/air/", "/air"].includes(pathName)) {
        return <Redirect to="/air/home" />;
      } else {
        return <Redirect to="/notFound" />;
      }
    } else if (pathNameSplit[1] === "flms") {
      const validPaths = [
        "/flms/home",
        "/flms/help",
        "/flms/details",
        "/flms/drivers",
        "/flms/driver_details",
        "/flms/vehicleDetails",
        "/flms/statistics",
        "/flms/vehicleAlert",
        "/flms/vehicleAlertList",
        "/flms/vehicleReport",
        "/flms/vehicleScheduleReport",
        "/flms/all/alert",
        "/flms/stats"
      ];
      if (validPaths.includes(pathName)) {
        return children;
      } else if (["/flms/", "/flms"].includes(pathName)) {
        return <Redirect to="/flms/home" />;
      } else {
        return <Redirect to="/notFound" />;
      }
    }else if (pathNameSplit[1] === "solar") {
      const validPaths = [
        "/solar/home",
        "/solar/details",
        "/solar/alarms",
        "/solar/alarms_list",
        "/solar/all/alert",
        "/solar/analysis",
        "/solar/help"
      ];
      if (validPaths.includes(pathName)) {
        return children;
      } else if (["/solar/", "/solar"].includes(pathName)) {
        return <Redirect to="/solar/home" />;
      } else {
        return <Redirect to="/notFound" />;
      }
    }

    else if (pathName === "/subscription") {
      return children;
    } else if (pathName === "/notFound") {
      return children;
    } else if (pathName === "/login") {
      // console.log("----------------------------------148");
      return children;
    } else if (pathName === "/forgot") {
      return children;
    } else if (
      [
        "/admin/home",
        "/superAdmin/home",
        "/admin/user",
        "/superAdmin/user",
      ].includes(pathName)
    ) {
      // this will redirect dashboard when user login from admin/home to the user dashboard . other-wise it will go to notFound section if remove this if block
      return <Redirect to="/" />;
    } else {
      // console.log("----------------------------------151");
      return <Redirect to="/notFound" />;
    }
  } else {
    if (pathName === "/notFound") {
      return children;
    } else {
      // console.log("----------------------------------166");
      return <Redirect to="/notFound" />;
    }
  }
};

AuthGuard.propTypes = {
  children: PropTypes.node,
};

export default AuthGuard;
